import { Action, createReducer, on } from '@ngrx/store';

import * as LocationActions from './location.actions';
import * as LocationFeatureState from './location.state';

const locationReducer = createReducer(
  LocationFeatureState.initialLocationState,

  on(LocationActions.setLocation, (state, { locationModel }) => {
    return { ...state, locationModel };
  }),

  on(LocationActions.removeLocation, (state) => {
    return LocationFeatureState.locationStateAdapter.removeAll({
      ...state,
      locationModel: null
    });
  }),

  on(LocationActions.receivedOccupationList, (state, { entities }) => {
    return LocationFeatureState.locationStateAdapter.addMany(entities, {
      ...state
    });
  })
);

export function reducer(
  state: LocationFeatureState.LocationState | undefined,
  action: Action
) {
  return locationReducer(state, action);
}
